// export const baseUrl="http://192.168.100.6:8000";
export const baseUrl="https://swiftimmigration.online/backend/public";

